module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-zoom-fc6d7d0c4e6c11264cc323ccb2626e64.jpg";